import { useEffect, useState } from "react";
import NavbarTop from "../../components/NavbarTop";
import { getPlatform } from "../../utils/platform";
import "./style.css"
import { Helmet } from "react-helmet-async";
import { ArrowBigDown } from "lucide-react";
import { ArrowDown } from "react-feather";
 
const Download = () => {
    const [platform, setPlatform] = useState<'MacOS' | 'Windows' | 'Android' | 'iOS' | 'other'>('other');
    const platformSecondButton = platform == "Windows" ? "Android" : "iOS"; 

    useEffect(() => {
        setPlatform(getPlatform());
    }, []);
    
    const platformText = {
        MacOS: 'Baixar para MacOS',
        Windows: 'Baixar para Windows',
        Android: 'Baixar para Android',
        iOS: 'Baixar para iOS',
        other: 'Baixar Paçoca Desktop',
    };

    const link = {
        "MacOS": "https://download1334.mediafire.com/ydag05ioe9dgRRdyQ830cZj39PdmGx66SViTiMHU4Bo-NCaXfeT28dKmdkvYOtBgDMFsg1P_B-_-hb030iyK8AoyPgC9TQOSJxQLtYgEsE7opyb4Cpy14mn9M-T2lofh1znGozM8po0mxch7jOHvUK_YEWBsr0Gr5eK49nlhgYSrrKOQ/wqgu8xzc7jpf778/Pacoca+Installer.dmg",
        "Windows": "https://download1580.mediafire.com/kzb8x7x9387gSQxlRnFxKodsr6gL59_VK_bU4NwVuGpi1nYPWnbXG0iokYczrpE6FHOh8otIbF8C4RESOzHNKa_JXgcNSVE6_JTTpxBGdeAA_BB7LBcudfj7wvNn_-OrTE0qxvRRwwYhcFPGXLlTMxC7NvJ5J5UHD5837mNgB8oRUb9E/vd5lp8x16cfzcw7/Pacoca+Installer.exe",
        "Android": "https://play.google.com/store/apps/details?id=com.joaoalves.pacoca&pcampaignid=web_share",
        "iOS": "https://apps.apple.com/us/app/pa%C3%A7oca/id6742334455",
        "other": "#",
    }

    return (
        <>
                <Helmet>
                        <title>Paçoca - Baixar Paçoca</title>
                        <meta name="description" content={`Baixe o Paçoca, a rede social 100% brasileira!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Baixar Paçoca, premium, download, ios, apple, android, windows, linux}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Baixar o Paçoca`}/>
                        <meta property="og:description" content={`Baixe o Paçoca, a rede social 100% brasileira!`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Baixar o Paçoca`}/>
                        <meta name="twitter:description" content={`Baixe o Paçoca, a rede social 100% brasileira`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <NavbarTop/>
                <div className="container-download">
                    <div className="download-section">
                        <h1 className="title-bold">Baixe o Paçoca</h1>
                        <p className="text-gray">Sua nova rede social</p>

                        <div className="div-buttons gap-10">
                            <div className="dropdown">
                                <a target={link[platform].includes("https") ? "_blank" : "_self"} href={link[platform]} className="download-btn">
                                    <p style={{marginLeft: "20px!important"}}>
                                        {(platform == "MacOS" || platform == "iOS") && <img src="/download-app/download-icon-apple.webp" style={{marginBottom: "3px"}} className="download-icon" /> }
                                        {(platform == "Windows") && <img src="/download-app/download-icon-windows.webp" style={{marginBottom: "3px"}} className="download-icon" /> }
                                        {(platform == "Android") && <img src="/download-app/download-icon-android.png" style={{marginBottom: "3px"}} className="download-icon" /> }
                                        {(platform == "iOS") && <img src="/download-app/download-icon-apple.png" style={{marginBottom: "3px"}} className="download-icon" /> }
                                        {platformText[platform]}
                                    </p>

                                    <div className="arrow-wrapper">
                                        <span className="arrow" onClick={(e) => { e.preventDefault() } }>
                                            <ArrowDown />
                                        </span>
                                        <div className="dropdown-content">
                                            <div className="wrap">
                                                {platform != "MacOS" && (
                                                    <a href={link.MacOS}>
                                                        <img src="/download-app/download-icon-apple.webp" className="download-icon" />
                                                        Baixar para MacOS
                                                    </a>
                                                )}
                                              
                                                {platform != "Windows" && (
                                                    <a href={link.Windows}>
                                                        <img src="/download-app/download-icon-windows.webp" className="download-icon" />
                                                        Baixar para Windows
                                                    </a>
                                                )}

                                                {platform != "Android" && platform != "Windows" && platform != "MacOS" && (
                                                    <a href={link.Android} target="_BLANK">
                                                        <img src="/download-app/download-icon-android.png" className="download-icon" />
                                                        Baixar para Android
                                                    </a>
                                                )}

                                                {platform != "iOS" && platform != "Windows" && platform != "MacOS" && (
                                                    <a href={link.iOS} target="_BLANK">
                                                        <img src="/download-app/download-icon-apple.webp" className="download-icon" />
                                                        Baixar para iOS
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                                <span className="none-cel">
                                        <a target={link[platformSecondButton].includes("https") ? "_blank" : "_self"} href={link[platformSecondButton]} className="download-btn">
                                            <p style={{marginLeft: "20px!important"}}>
                                                {platformSecondButton == "iOS" ? <img src="/download-app/download-icon-apple.webp" style={{marginBottom: "3px"}} className="download-icon" /> : null}
                                                {platformSecondButton == "Android" ? <img src="/download-app/download-icon-android.png" style={{marginBottom: "3px"}} className="download-icon" /> : null}
                                                
                                                {platformText[platformSecondButton]}
                                            </p>

                                            <div className="arrow-wrapper">
                                                <span className="arrow" onClick={(e) => { e.preventDefault() } }>
                                                    <ArrowDown />
                                                </span>
                                                <div className="dropdown-content">
                                                    <div className="wrap">
                                                        {platform != "Android" && platform != "Windows" && (
                                                            <a href={link.Android} target="_BLANK">
                                                                <img src="/download-app/download-icon-android.png" className="download-icon" />
                                                                Baixar para Android
                                                            </a>
                                                        )}

                                                        {platform != "iOS" && platform != "MacOS" && (
                                                            <a href={link.iOS} target="_BLANK">
                                                                <img src="/download-app/download-icon-apple.webp" className="download-icon" />
                                                                Baixar para iOS
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </span>
                                </div>

                            {/* {platform != "Android" && platform != "iOS" && (
                                <a
                                    className="download-btn"
                                    style={{ textDecoration: "none" }}
                                    target="_BLANK"
                                    href="https://play.google.com/store/apps/details?id=com.joaoalves.pacoca&pcampaignid=web_share"
                                >
                                    <div>Android (Google Play Store)</div>
                                </a>
                            )} */}

                            <p className="text-gray mt-5">Disponível em todos os sistemas operacionais</p>
                        </div>
                    </div>
                </div>
        </>
    );
};

export default Download;